import React from 'react';

import CustomTd from '../shared/table/CustomTd';
import formatter from '../../utilities/formatter';

const DailyLeadLogItem = ({ item }) => {
    return (
        <tr>
            <CustomTd>
                {formatter.date(item.dateCreated)}
            </CustomTd>
            <CustomTd>
                {formatter.date(item.startTime)}
            </CustomTd>
            <CustomTd>
                {item.firstName}
            </CustomTd>
            <CustomTd>
                {item.lastName}
            </CustomTd>
            <CustomTd>
                {item.address}
            </CustomTd>
            <CustomTd>
                {item.phone}
            </CustomTd>
            <CustomTd>
                {item.email}
            </CustomTd>
            <CustomTd>
                {item.areaCount}
            </CustomTd>
            <CustomTd>
                {item.leadSource}
            </CustomTd>
            <CustomTd>
                {item.subLeadSource}
            </CustomTd>
            <CustomTd>
                {item.designer}
            </CustomTd>
            <CustomTd>
                {item.createdBy}
            </CustomTd>
            <CustomTd colSpan={2}>
                {item.note}
            </CustomTd>
        </tr>
    );
}

export default DailyLeadLogItem;